import { useEffect, useState } from "react";
import { dayjsSingaporeTimezone } from "@util/constant";
import dayjs from "dayjs";

/** Custom hook to check if the published date is more than 180 days ago. */
const usePublishedTime = (publishedDate: string) => {
  const [isMoreThan60DaysAgo, setIs60DaysAgo] = useState(false);
  const [isMoreThan90DaysAgo, setIs90DaysAgo] = useState(false);
  const [isMoreThan180DaysAgo, setIs180DaysAgo] = useState(false);

  useEffect(() => {
    const now = dayjs().tz(dayjsSingaporeTimezone);
    const pub = dayjs(publishedDate).tz(dayjsSingaporeTimezone);
    const diff = now.diff(pub, "days");

    setIs60DaysAgo(diff > 60);
    setIs90DaysAgo(diff > 90);
    setIs180DaysAgo(diff > 180);
  }, [publishedDate]);

  return { isMoreThan60DaysAgo, isMoreThan90DaysAgo, isMoreThan180DaysAgo };
};

export default usePublishedTime;
